const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const API_PREFIX = API_BASE_URL ? `${API_BASE_URL}/api` : '/api';
const API_ORIGIN = API_BASE_URL;

export const getImageUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const cleanPath = path.replace(/\\/g, '/');
    const normalizedPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
    return `${API_ORIGIN}${normalizedPath}`;
};

const publicFetch = async (endpoint, options = {}) => {
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    const url = `${API_PREFIX}${cleanEndpoint}`;

    const mergedOptions = {
        headers: {
            'Content-Type': 'application/json',
            ...(options.headers || {}),
        },
        ...options,
    };

    if (mergedOptions.body instanceof FormData) {
        delete mergedOptions.headers['Content-Type'];
    }

    try {
        const response = await fetch(url, mergedOptions);

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            const error = new Error(errorData.detail || `Ошибка ${response.status}`);
            error.status = response.status;
            throw error;
        }

        if (response.status === 204) return null;

        const contentType = response.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) return null;

        return await response.json();
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const publicApi = {
    catalog: {
        getAll: async () => {
            const data = await publicFetch('catalog/');
            return data.map((product) => ({
                ...product,
                images: (product.images || []).map((img) => getImageUrl(img)),
            }));
        },
    },
    products: {
        getAll: async (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            const endpoint = queryString ? `products?${queryString}` : 'products';
            const data = await publicFetch(endpoint);

            return data.map((product) => ({
                ...product,
                images: (product.images || []).map((img) => getImageUrl(img)),
            }));
        },
    },

    itemInstances: {
        getByProduct: (productId) => publicFetch(`instances/?product_id=${productId}`),
    },

    promo_codes: {
        check: (code) => publicFetch('promocodes/check', {
            method: 'POST',
            body: JSON.stringify({ code }),
        }),
    },

    purchases: {
        getPublic: (id, token) => publicFetch(`purchases/${id}/public?token=${token}`),
    },

    checkout: {
        create: (data) => publicFetch('checkout', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
    },

    siteConfig: {
        get: () => publicFetch('site-config'),
    },
};

export default publicApi;
